import type { State } from './typings'

export const initialState: State = {
  referralType: undefined,
  referralEmployeeId: '',
  referralEmployeeValue: '',
  referralCustomerId: '',
  referralCustomerIdTemp: '',
  referralOther: '',
  referralDiscountId: '',
  referralDiscountCode: '',
  referralDiscountValue: 0,
  referralLocationCode: '',
}
